/**
 * PostStats 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostStats
 */
export interface PostStats {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键，和主表的主键一致 */
  id?: string
  /** 点赞次数 */
  like_count?: number
  /** 总评论数 */
  comment_count?: number
  /** 直接评论数 */
  direct_comment_count?: number
  /** 分享次数 */
  share_count?: number
  /** 收藏次数 */
  collect_count?: number
  /** 浏览次数 */
  view_count?: number
  /** 点踩次数 */
  dislike_count?: number
  /** 被举报次数 */
  report_count?: number
  /** 最近评论时间 */
  last_commented_at?: string
  /** 最近评论用户ID */
  last_commented_user_id?: string
  /** 最近点赞时间 */
  last_liked_at?: string
  /** 最近点赞用户ID */
  last_liked_user_id?: string
  /** 最近点踩时间 */
  last_disliked_at?: string
  /** 最近点踩用户ID */
  last_disliked_user_id?: string
  /** 最近收藏时间 */
  last_collected_at?: string
  /** 最近收藏用户ID */
  last_collected_user_id?: string
  /** 最近分享时间 */
  last_shared_at?: string
  /** 最近分享用户ID */
  last_shared_user_id?: string
  /** 最近浏览时间 */
  last_viewed_at?: string
  /** 最近浏览用户ID */
  last_viewed_user_id?: string
}

/**
 * PostStats Schema
 */
export const PostStatsSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键，和主表的主键一致',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    like_count: {
      description: '点赞次数',
      format: 'int',
      type: 'integer',
      label: '点赞次数',
    },
    comment_count: {
      description: '总评论数',
      format: 'int',
      type: 'integer',
      label: '总评论数',
    },
    direct_comment_count: {
      description: '直接评论数',
      format: 'int',
      type: 'integer',
      label: '直接评论数',
    },
    share_count: {
      description: '分享次数',
      format: 'int',
      type: 'integer',
      label: '分享次数',
    },
    collect_count: {
      description: '收藏次数',
      format: 'int',
      type: 'integer',
      label: '收藏次数',
    },
    view_count: {
      description: '浏览次数',
      format: 'int',
      type: 'integer',
      label: '浏览次数',
    },
    dislike_count: {
      description: '点踩次数',
      format: 'int',
      type: 'integer',
      label: '点踩次数',
    },
    report_count: {
      description: '被举报次数',
      format: 'int',
      type: 'integer',
      label: '被举报次数',
    },
    last_commented_at: {
      description: '最近评论时间',
      format: '*time.Time',
      type: 'string',
      label: '最近评论时间',
    },
    last_commented_user_id: {
      description: '最近评论用户ID',
      format: 'string',
      type: 'string',
      label: '最近评论用户ID',
    },
    last_liked_at: {
      description: '最近点赞时间',
      format: '*time.Time',
      type: 'string',
      label: '最近点赞时间',
    },
    last_liked_user_id: {
      description: '最近点赞用户ID',
      format: 'string',
      type: 'string',
      label: '最近点赞用户ID',
    },
    last_disliked_at: {
      description: '最近点踩时间',
      format: '*time.Time',
      type: 'string',
      label: '最近点踩时间',
    },
    last_disliked_user_id: {
      description: '最近点踩用户ID',
      format: 'string',
      type: 'string',
      label: '最近点踩用户ID',
    },
    last_collected_at: {
      description: '最近收藏时间',
      format: '*time.Time',
      type: 'string',
      label: '最近收藏时间',
    },
    last_collected_user_id: {
      description: '最近收藏用户ID',
      format: 'string',
      type: 'string',
      label: '最近收藏用户ID',
    },
    last_shared_at: {
      description: '最近分享时间',
      format: '*time.Time',
      type: 'string',
      label: '最近分享时间',
    },
    last_shared_user_id: {
      description: '最近分享用户ID',
      format: 'string',
      type: 'string',
      label: '最近分享用户ID',
    },
    last_viewed_at: {
      description: '最近浏览时间',
      format: '*time.Time',
      type: 'string',
      label: '最近浏览时间',
    },
    last_viewed_user_id: {
      description: '最近浏览用户ID',
      format: 'string',
      type: 'string',
      label: '最近浏览用户ID',
    },
  },
  type: 'object',
}
